import {combineReducers} from "redux";
import {
    APP_STATE,
    LOGIN_STATES,
    SET_APP_STATE,
    SET_HEADER,
    SET_LOGIN_CREDENTIALS,
    SET_LOGIN_STATE,
    SET_USER_DATA
} from "./actionTypes";

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCircleNotch} from '@fortawesome/pro-solid-svg-icons'
import React from "react";

function loginCredentials(state = {user: '', token: ''}, action = undefined) {
    if (action.type === SET_LOGIN_CREDENTIALS) {
        return {
            user: action.user,
            token: action.token,
        };
    } else {
        return state;
    }
}

function loginState(state = LOGIN_STATES.TRY_LOGIN, action = undefined) {
    if (action.type === SET_LOGIN_STATE) {
        return action.state;
    } else {
        return state;
    }
}

function userData(state = {access: []}, action = undefined) {
    if (action.type === SET_USER_DATA) {
        return {access: action.access};
    } else {
        return state;
    }
}

function header(state = {title: 'Loading', icon: <FontAwesomeIcon icon={faCircleNotch} spin/>}, action = undefined) {
    if (action.type === SET_HEADER) {
        return {
            title: action.title,
            icon: action.icon,
        };
    } else {
        return state;
    }
}

function appState(state = APP_STATE.INITIALISING, action = undefined) {
    if (action.type === SET_APP_STATE) {
        return action.state;
    } else {
        return state;
    }
}

let AppStorage = combineReducers({
    loginCredentials,
    loginState,
    appState,
    userData,
    header,
});

export {loginCredentials, loginState, appState, userData, header}

export default AppStorage